module.exports = __webpack_public_path__ + "static/media/circle_image.04f9f5d3.png";